import { render, staticRenderFns } from "./routerMenus.vue?vue&type=template&id=33970ed7&scoped=true&"
import script from "./routerMenus.vue?vue&type=script&lang=js&"
export * from "./routerMenus.vue?vue&type=script&lang=js&"
import style0 from "./routerMenus.vue?vue&type=style&index=0&id=33970ed7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33970ed7",
  null
  
)

export default component.exports